<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Settings</h1>
      </div>
    </div>

    <div class="container-fluid">
      <system-settings-payment/>

      <system-settings-notifications/>

      <system-settings-custom-fields :endpoint="'settings/booking_custom_field'" :attribute="'booking_custom_fields'" :title="'Booking Custom Fields'" :customFieldValues="this.settings.booking_custom_fields" v-if="settings && settings.booking_custom_fields !== undefined"/>

      <system-settings-custom-fields :endpoint="'settings/user_custom_field'" :attribute="'user_custom_fields'" :title="'User Custom Fields'" :customFieldValues="this.settings.user_custom_fields" v-if="settings && settings.user_custom_fields !== undefined"/>

      <system-settings-terms-and-condition/>

      <system-settings-social-media/>

      <system-settings-app-version />

      <system-settings-others />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SystemSettingsPayment from './SystemSettingsPayment'
import SystemSettingsTermsAndCondition from './SystemSettingsTermsAndCondition'
import SystemSettingsCustomFields from './SystemSettingsCustomFields'
import SystemSettingsNotifications from './SystemSettingsNotifications'
import SystemSettingsSocialMedia from './SystemSettingsSocialMedia'
import SystemSettingsAppVersion from './SystemSettingsAppVersion'
import SystemSettingsOthers from './SystemSettingsOthers'

export default {
  components: {
    SystemSettingsAppVersion,
    SystemSettingsPayment,
    SystemSettingsNotifications,
    SystemSettingsTermsAndCondition,
    SystemSettingsCustomFields,
    SystemSettingsSocialMedia,
    SystemSettingsOthers
  },

  computed: {
    ...mapState('settings', ['settings'])
  },

  created () {
    this.getSettings()
  },

  methods: mapActions('settings', ['getSettings'])
}
</script>
